// for dynamic imports, use
// https://wanago.io/2018/08/20/webpack-4-course-part-eight-dynamic-imports-with-prefetch-and-preload/
// with webpackExclude to not bundle files like _Base.ts or what is under utils/
// with webpackChunkName and [request] to ensure meaningful name
// more on https://webpack.js.org/api/module-methods/
import {CATEGORY_SOP} from './Category';

import {ActorSopNode} from '../../../nodes/sop/Actor';
import {AddSopNode} from '../../../nodes/sop/Add';
import {AmbientLightSopNode} from '../../../nodes/sop/AmbientLight';
import {AnimationCopySopNode} from '../../../nodes/sop/AnimationCopy';
// import {AnimationMixerSopNode} from '../../../nodes/sop/AnimationMixer';
import {AreaLightSopNode} from '../../../nodes/sop/AreaLight';
import {AttribAddMultSopNode} from '../../../nodes/sop/AttribAddMult';
// import {AttribAudioAnalyserSopNode} from '../../../nodes/sop/AttribAudioAnalyser';
import {AttribCastSopNode} from '../../../nodes/sop/AttribCast';
import {AttribCopySopNode} from '../../../nodes/sop/AttribCopy';
import {AttribCreateSopNode} from '../../../nodes/sop/AttribCreate';
import {AttribDeleteSopNode} from '../../../nodes/sop/AttribDelete';
import {AttribFromTextureSopNode} from '../../../nodes/sop/AttribFromTexture';
import {AttribIdSopNode} from '../../../nodes/sop/AttribId';
import {AttribNormalizeSopNode} from '../../../nodes/sop/AttribNormalize';
import {AttribPromoteSopNode} from '../../../nodes/sop/AttribPromote';
import {AttribRemapSopNode} from '../../../nodes/sop/AttribRemap';
import {AttribRenameSopNode} from '../../../nodes/sop/AttribRename';
import {AttribSetAtIndexSopNode} from '../../../nodes/sop/AttribSetAtIndex';
import {AttribTransferSopNode} from '../../../nodes/sop/AttribTransfer';
import {AudioNotesSopNode} from '../../../nodes/sop/AudioNotes';
import {AxesHelperSopNode} from '../../../nodes/sop/AxesHelper';
import {BboxScatterSopNode} from '../../../nodes/sop/BboxScatter';
import {BlendSopNode} from '../../../nodes/sop/Blend';
import {BooleanSopNode} from '../../../nodes/sop/Boolean';
import {BoxSopNode} from '../../../nodes/sop/Box';
import {BoxLinesSopNode} from '../../../nodes/sop/BoxLines';
import {BVHSopNode} from '../../../nodes/sop/BVH';
import {BVHVisualizerSopNode} from '../../../nodes/sop/BVHVisualizer';
import {CacheSopNode} from '../../../nodes/sop/Cache';
import {CameraControlsSopNode} from '../../../nodes/sop/CameraControls';
import {CameraCSSRendererSopNode} from '../../../nodes/sop/CameraCSSRenderer';
import {CameraFrameModeSopNode} from '../../../nodes/sop/CameraFrameMode';
import {CameraPlaneSopNode} from '../../../nodes/sop/CameraPlane';
import {CameraPostProcessSopNode} from '../../../nodes/sop/CameraPostProcess';
import {CameraProjectSopNode} from '../../../nodes/sop/CameraProject';
import {CameraRenderSceneSopNode} from '../../../nodes/sop/CameraRenderScene';
import {CameraRendererSopNode} from '../../../nodes/sop/CameraRenderer';
import {CapsuleSopNode} from '../../../nodes/sop/Capsule';
import {CenterSopNode} from '../../../nodes/sop/Center';
import {CircleSopNode} from '../../../nodes/sop/Circle';
import {Circle3PointsSopNode} from '../../../nodes/sop/Circle3Points';
import {ClipSopNode} from '../../../nodes/sop/Clip';
import {CodeSopNode} from '../../../nodes/sop/Code';
import {ColorSopNode} from '../../../nodes/sop/Color';
import {ConeSopNode} from '../../../nodes/sop/Cone';
import {CopySopNode} from '../../../nodes/sop/Copy';
import {CurveFromPointsSopNode} from '../../../nodes/sop/CurveFromPoints';
import {CurveGetPointSopNode} from '../../../nodes/sop/CurveGetPoint';
import {CSS2DObjectSopNode} from '../../../nodes/sop/CSS2DObject';
import {CSS3DObjectSopNode} from '../../../nodes/sop/CSS3DObject';
import {DataSopNode} from '../../../nodes/sop/Data';
import {DataUrlSopNode} from '../../../nodes/sop/DataUrl';
import {DecalSopNode} from '../../../nodes/sop/Decal';
import {DelaySopNode} from '../../../nodes/sop/Delay';
import {DeleteSopNode} from '../../../nodes/sop/Delete';
import {DirectionalLightSopNode} from '../../../nodes/sop/DirectionalLight';
import {DrawRangeSopNode} from '../../../nodes/sop/DrawRange';
import {EmptyObjectSopNode} from '../../../nodes/sop/EmptyObject';
import {ExporterSopNode} from '../../../nodes/sop/Exporter';
import {FaceSopNode} from '../../../nodes/sop/Face';
import {FacetSopNode} from '../../../nodes/sop/Facet';
// import {FileSopNode} from '../../../nodes/sop/File';
import {FileDRCSopNode} from '../../../nodes/sop/FileDRC';
import {FileFBXSopNode} from '../../../nodes/sop/FileFBX';
import {FileGLTFSopNode} from '../../../nodes/sop/FileGLTF';
import {FileJSONSopNode} from '../../../nodes/sop/FileJSON';
import {FileMPDSopNode} from '../../../nodes/sop/FileMPD';
import {FileMultiGLTFSopNode} from '../../../nodes/sop/FileMultiGLTF';
import {FileMultiOBJSopNode} from '../../../nodes/sop/FileMultiOBJ';
import {FileOBJSopNode} from '../../../nodes/sop/FileOBJ';
import {FilePDBSopNode} from '../../../nodes/sop/FilePDB';
import {FilePLYSopNode} from '../../../nodes/sop/FilePLY';
import {FileSTLSopNode} from '../../../nodes/sop/FileSTL';
import {FileSVGSopNode} from '../../../nodes/sop/FileSVG';
import {FuseSopNode} from '../../../nodes/sop/Fuse';
import {HexagonsSopNode} from '../../../nodes/sop/Hexagons';
import {HierarchySopNode} from '../../../nodes/sop/Hierarchy';
import {HeightMapSopNode} from '../../../nodes/sop/HeightMap';
import {HemisphereLightSopNode} from '../../../nodes/sop/HemisphereLight';
import {IcosahedronSopNode} from '../../../nodes/sop/Icosahedron';
import {InstanceSopNode} from '../../../nodes/sop/Instance';
import {InstanceUpdateSopNode} from '../../../nodes/sop/InstanceUpdate';
import {InstancesCountSopNode} from '../../../nodes/sop/InstancesCount';
import {JitterSopNode} from '../../../nodes/sop/Jitter';
// import {JsPointSopNode} from '../../../nodes/sop/JsPoint';
import {LayerSopNode} from '../../../nodes/sop/Layer';
import {LightMixerSopNode} from '../../../nodes/sop/LightMixer';
import {LineSopNode} from '../../../nodes/sop/Line';
import {LodSopNode} from '../../../nodes/sop/Lod';
import {LookAtSopNode} from '../../../nodes/sop/LookAt';
import {MaterialSopNode} from '../../../nodes/sop/Material';
import {MaterialPropertiesSopNode} from '../../../nodes/sop/MaterialProperties';
import {MergeSopNode} from '../../../nodes/sop/Merge';
import {MetaballSopNode} from '../../../nodes/sop/Metaball';
import {NoiseSopNode} from '../../../nodes/sop/Noise';
import {NormalsSopNode} from '../../../nodes/sop/Normals';
import {NormalsHelperSopNode} from '../../../nodes/sop/NormalsHelper';
import {NullSopNode} from '../../../nodes/sop/Null';
import {ObjectMergeSopNode} from '../../../nodes/sop/ObjectMerge';
import {ObjectPropertiesSopNode} from '../../../nodes/sop/ObjectProperties';
import {ObjectsLayoutSopNode} from '../../../nodes/sop/ObjectsLayout';
import {OceanPlaneSopNode} from '../../../nodes/sop/OceanPlane';
import {OperationsComposerSopNode} from '../../../nodes/sop/OperationsComposer';
import {OrthographicCameraSopNode} from '../../../nodes/sop/OrthographicCamera';
import {PaletteSopNode} from '../../../nodes/sop/Palette';
import {ParticlesSystemGpuSopNode} from '../../../nodes/sop/ParticlesSystemGpu';
import {PeakSopNode} from '../../../nodes/sop/Peak';
import {PerspectiveCameraSopNode} from '../../../nodes/sop/PerspectiveCamera';
import {PhysicsGroundSopNode} from '../../../nodes/sop/PhysicsGround';
import {PhysicsJointsSopNode} from '../../../nodes/sop/PhysicsJoints';
import {PhysicsRBDAttributesSopNode} from '../../../nodes/sop/PhysicsRBDAttributes';
import {PhysicsWorldSopNode} from '../../../nodes/sop/PhysicsWorld';
import {PlaneSopNode} from '../../../nodes/sop/Plane';
import {PlaneHelperSopNode} from '../../../nodes/sop/PlaneHelper';
import {PointSopNode} from '../../../nodes/sop/Point';
import {PointLightSopNode} from '../../../nodes/sop/PointLight';
import {PolarTransformSopNode} from '../../../nodes/sop/PolarTransform';
import {PolywireSopNode} from '../../../nodes/sop/Polywire';
import {RaySopNode} from '../../../nodes/sop/Ray';
import {ReflectorSopNode} from '../../../nodes/sop/Reflector';
import {ResampleSopNode} from '../../../nodes/sop/Resample';
import {RestAttributesSopNode} from '../../../nodes/sop/RestAttributes';
import {RoundedBoxSopNode} from '../../../nodes/sop/RoundedBox';
import {ScatterSopNode} from '../../../nodes/sop/Scatter';
import {SetChildrenSopNode} from '../../../nodes/sop/SetChildren';
import {SetGeometrySopNode} from '../../../nodes/sop/SetGeometry';
import {ShearSopNode} from '../../../nodes/sop/Shear';
import {SkeletonHelperSopNode} from '../../../nodes/sop/SkeletonHelper';
import {SkinSopNode} from '../../../nodes/sop/Skin';
import {SortSopNode} from '../../../nodes/sop/Sort';
import {SolverSopNode} from '../../../nodes/sop/Solver';
import {SolverPreviousFrameSopNode} from '../../../nodes/sop/SolverPreviousFrame';
import {SphereSopNode} from '../../../nodes/sop/Sphere';
import {SplitSopNode} from '../../../nodes/sop/Split';
import {SpotLightSopNode} from '../../../nodes/sop/SpotLight';
import {SubdivideSopNode} from '../../../nodes/sop/Subdivide';
import {SubnetSopNode} from '../../../nodes/sop/Subnet';
import {SubnetInputSopNode} from '../../../nodes/sop/SubnetInput';
import {SubnetOutputSopNode} from '../../../nodes/sop/SubnetOutput';
import {SwitchSopNode} from '../../../nodes/sop/Switch';
import {TetrahedronSopNode} from '../../../nodes/sop/Tetrahedron';
import {TextSopNode} from '../../../nodes/sop/Text';
import {TextureCopySopNode} from '../../../nodes/sop/TextureCopy';
import {TexturePropertiesSopNode} from '../../../nodes/sop/TextureProperties';
import {TorusSopNode} from '../../../nodes/sop/Torus';
import {TorusKnotSopNode} from '../../../nodes/sop/TorusKnot';
import {TransformSopNode} from '../../../nodes/sop/Transform';
import {TransformCopySopNode} from '../../../nodes/sop/TransformCopy';
import {TransformMultiSopNode} from '../../../nodes/sop/TransformMulti';
import {TransformResetSopNode} from '../../../nodes/sop/TransformReset';
import {TubeSopNode} from '../../../nodes/sop/Tube';
import {UvLayoutSopNode} from '../../../nodes/sop/UvLayout';
import {UvProjectSopNode} from '../../../nodes/sop/UvProject';
import {UvTransformSopNode} from '../../../nodes/sop/UvTransform';
import {UvUnwrapSopNode} from '../../../nodes/sop/UvUnwrap';
// networks
import {ActorsNetworkSopNode} from '../../../nodes/sop/ActorsNetwork';
import {AnimationsNetworkSopNode} from '../../../nodes/sop/AnimationsNetwork';
import {AudioNetworkSopNode} from '../../../nodes/sop/AudioNetwork';
import {CopNetworkSopNode} from '../../../nodes/sop/CopNetwork';
import {CsgNetworkSopNode} from '../../../nodes/sop/CsgNetwork';
import {EventsNetworkSopNode} from '../../../nodes/sop/EventsNetwork';
import {MaterialsNetworkSopNode} from '../../../nodes/sop/MaterialsNetwork';
import {PostProcessNetworkSopNode} from '../../../nodes/sop/PostProcessNetwork';
import {RenderersNetworkSopNode} from '../../../nodes/sop/RenderersNetwork';

export interface GeoNodeChildrenMap {
	actor: ActorSopNode;
	add: AddSopNode;
	ambientLight: AmbientLightSopNode;
	animationCopy: AnimationCopySopNode;
	// animationMixer: AnimationMixerSopNode;
	areaLight: AreaLightSopNode;
	attribAddMult: AttribAddMultSopNode;
	// attribAudioAnalyser: AttribAudioAnalyserSopNode;
	attribCast: AttribCastSopNode;
	attribCopy: AttribCopySopNode;
	attribCreate: AttribCreateSopNode;
	attribDelete: AttribDeleteSopNode;
	attribFromTexture: AttribFromTextureSopNode;
	attribId: AttribIdSopNode;
	attribNormalize: AttribNormalizeSopNode;
	attribPromote: AttribPromoteSopNode;
	attribRemap: AttribRemapSopNode;
	attribRename: AttribRenameSopNode;
	attribSetAtIndex: AttribSetAtIndexSopNode;
	attribTransfer: AttribTransferSopNode;
	audioNotes: AudioNotesSopNode;
	axesHelper: AxesHelperSopNode;
	bboxScatter: BboxScatterSopNode;
	blend: BlendSopNode;
	boolean: BooleanSopNode;
	box: BoxSopNode;
	boxLines: BoxLinesSopNode;
	BVH: BVHSopNode;
	BVHVisualizer: BVHVisualizerSopNode;
	cache: CacheSopNode;
	cameraControls: CameraControlsSopNode;
	cameraCSSRenderer: CameraCSSRendererSopNode;
	cameraFrameMode: CameraFrameModeSopNode;
	cameraPlane: CameraPlaneSopNode;
	cameraPostProcess: CameraPostProcessSopNode;
	cameraProject: CameraProjectSopNode;
	cameraRenderer: CameraRendererSopNode;
	cameraRenderScene: CameraRenderSceneSopNode;
	capsule: CapsuleSopNode;
	center: CenterSopNode;
	circle: CircleSopNode;
	circle3Points: Circle3PointsSopNode;
	clip: ClipSopNode;
	code: CodeSopNode;
	color: ColorSopNode;
	cone: ConeSopNode;
	copy: CopySopNode;
	curveFromPoints: CurveFromPointsSopNode;
	curveGetPoint: CurveGetPointSopNode;
	CSS2DObject: CSS2DObjectSopNode;
	CSS3DObject: CSS3DObjectSopNode;
	data: DataSopNode;
	dataUrl: DataUrlSopNode;
	decal: DecalSopNode;
	delay: DelaySopNode;
	delete: DeleteSopNode;
	directionalLight: DirectionalLightSopNode;
	drawRange: DrawRangeSopNode;
	emptyObject: EmptyObjectSopNode;
	exporter: ExporterSopNode;
	face: FaceSopNode;
	facet: FacetSopNode;
	// file: FileSopNode;
	fileDRC: FileDRCSopNode;
	fileFBX: FileFBXSopNode;
	fileGLTF: FileGLTFSopNode;
	fileJSON: FileJSONSopNode;
	fileMPD: FileMPDSopNode;
	fileMultiGLTF: FileMultiGLTFSopNode;
	fileMultiOBJ: FileMultiOBJSopNode;
	fileOBJ: FileOBJSopNode;
	filePDB: FilePDBSopNode;
	filePLY: FilePLYSopNode;
	fileSTL: FileSTLSopNode;
	fileSVG: FileSVGSopNode;
	fuse: FuseSopNode;
	heightMap: HeightMapSopNode;
	hexagons: HexagonsSopNode;
	hierarchy: HierarchySopNode;
	hemisphereLight: HemisphereLightSopNode;
	icosahedron: IcosahedronSopNode;
	instance: InstanceSopNode;
	instanceUpdate: InstanceUpdateSopNode;
	instancesCount: InstancesCountSopNode;
	jitter: JitterSopNode;
	// jsPoint: JsPointSopNode;
	layer: LayerSopNode;
	lightMixer: LightMixerSopNode;
	line: LineSopNode;
	lod: LodSopNode;
	lookAt: LookAtSopNode;
	material: MaterialSopNode;
	materialProperties: MaterialPropertiesSopNode;

	merge: MergeSopNode;
	metaball: MetaballSopNode;
	noise: NoiseSopNode;
	normals: NormalsSopNode;
	normalsHelper: NormalsHelperSopNode;
	null: NullSopNode;
	objectMerge: ObjectMergeSopNode;
	objectProperties: ObjectPropertiesSopNode;
	objectsLayout: ObjectsLayoutSopNode;
	oceanPlane: OceanPlaneSopNode;
	operationsComposer: OperationsComposerSopNode;
	orthographicCamera: OrthographicCameraSopNode;
	palette: PaletteSopNode;
	particlesSystemGpu: ParticlesSystemGpuSopNode;
	peak: PeakSopNode;
	perspectiveCamera: PerspectiveCameraSopNode;
	physicsGround: PhysicsGroundSopNode;
	physicsJoints: PhysicsJointsSopNode;
	physicsRBDAttributes: PhysicsRBDAttributesSopNode;
	physicsWorld: PhysicsWorldSopNode;
	plane: PlaneSopNode;
	planeHelper: PlaneHelperSopNode;
	point: PointSopNode;
	pointLight: PointLightSopNode;
	polarTransform: PolarTransformSopNode;
	polywire: PolywireSopNode;
	ray: RaySopNode;
	reflector: ReflectorSopNode;
	resample: ResampleSopNode;
	restAttributes: RestAttributesSopNode;
	roundedBox: RoundedBoxSopNode;
	scatter: ScatterSopNode;
	setChildren: SetChildrenSopNode;
	setGeometry: SetGeometrySopNode;
	shear: ShearSopNode;
	skin: SkinSopNode;
	skeletonHelper: SkeletonHelperSopNode;
	solver: SolverSopNode;
	solverPreviousFrame: SolverPreviousFrameSopNode;
	sort: SortSopNode;
	sphere: SphereSopNode;
	split: SplitSopNode;
	spotLight: SpotLightSopNode;
	subdivide: SubdivideSopNode;
	subnet: SubnetSopNode;
	subnetInput: SubnetInputSopNode;
	subnetOutput: SubnetOutputSopNode;
	switch: SwitchSopNode;
	tetrahedron: TetrahedronSopNode;
	text: TextSopNode;
	textureCopy: TextureCopySopNode;
	textureProperties: TexturePropertiesSopNode;
	torus: TorusSopNode;
	torusKnot: TorusKnotSopNode;
	transform: TransformSopNode;
	transformCopy: TransformCopySopNode;
	transformMulti: TransformMultiSopNode;
	transformReset: TransformResetSopNode;
	tube: TubeSopNode;
	uvLayout: UvProjectSopNode;
	uvProject: UvProjectSopNode;
	uvTransform: UvTransformSopNode;
	uvUnwrap: UvUnwrapSopNode;

	// networks
	actorsNetwork: ActorsNetworkSopNode;
	animationsNetwork: AnimationsNetworkSopNode;
	audioNetwork: AudioNetworkSopNode;
	copNetwork: CopNetworkSopNode;
	csgNetwork: CsgNetworkSopNode;
	eventsNetwork: EventsNetworkSopNode;
	materialsNetwork: MaterialsNetworkSopNode;
	postProcessNetwork: PostProcessNetworkSopNode;
	renderersNetwork: RenderersNetworkSopNode;
}

import {AddSopOperation} from '../../../operations/sop/Add';
import {AmbientLightSopOperation} from '../../../operations/sop/AmbientLight';
import {AreaLightSopOperation} from '../../../operations/sop/AreaLight';
import {AttribAddMultSopOperation} from '../../../operations/sop/AttribAddMult';
import {AttribCastSopOperation} from '../../../operations/sop/AttribCast';
import {AttribCopySopOperation} from '../../../operations/sop/AttribCopy';
import {AttribCreateSopOperation} from '../../../operations/sop/AttribCreate';
import {AttribNormalizeSopOperation} from '../../../operations/sop/AttribNormalize';
import {AttribFromTextureSopOperation} from '../../../operations/sop/AttribFromTexture';
import {AttribIdSopOperation} from '../../../operations/sop/AttribId';
import {AttribPromoteSopOperation} from '../../../operations/sop/AttribPromote';
import {AttribRenameSopOperation} from '../../../operations/sop/AttribRename';
import {AttribSetAtIndexSopOperation} from '../../../operations/sop/AttribSetAtIndex';
import {AudioNotesSopOperation} from '../../../operations/sop/AudioNotes';
import {AxesHelperSopOperation} from '../../../operations/sop/AxesHelper';
import {BboxScatterSopOperation} from '../../../operations/sop/BboxScatter';
import {BooleanSopOperation} from '../../../operations/sop/Boolean';
import {BoxSopOperation} from '../../../operations/sop/Box';
import {BoxLinesSopOperation} from '../../../operations/sop/BoxLines';
import {BVHSopOperation} from '../../../operations/sop/BVH';
import {BVHVisualizerSopOperation} from '../../../operations/sop/BVHVisualizer';
import {CameraControlsSopOperation} from '../../../operations/sop/CameraControls';
import {CameraCSSRendererSopOperation} from '../../../operations/sop/CameraCSSRenderer';
import {CameraFrameModeSopOperation} from '../../../operations/sop/CameraFrameMode';
import {CameraPostProcessSopOperation} from '../../../operations/sop/CameraPostProcess';
import {CameraProjectSopOperation} from '../../../operations/sop/CameraProject';
import {CameraRendererSopOperation} from '../../../operations/sop/CameraRenderer';
import {CameraRenderSceneSopOperation} from '../../../operations/sop/CameraRenderScene';
import {CapsuleSopOperation} from '../../../operations/sop/Capsule';
import {CenterSopOperation} from '../../../operations/sop/Center';
import {CircleSopOperation} from '../../../operations/sop/Circle';
import {ClipSopOperation} from '../../../operations/sop/Clip';
import {CurveFromPointsSopOperation} from '../../../operations/sop/CurveFromPoints';
import {CurveGetPointSopOperation} from '../../../operations/sop/CurveGetPoint';
import {CSS2DObjectSopOperation} from '../../../operations/sop/CSS2DObject';
import {DecalSopOperation} from '../../../operations/sop/Decal';
import {DirectionalLightSopOperation} from '../../../operations/sop/DirectionalLight';
import {EmptyObjectSopOperation} from '../../../operations/sop/EmptyObject';
// import {FileSopOperation} from '../../../operations/sop/File';
import {FileDRCSopOperation} from '../../../operations/sop/FileDRC';
import {FileFBXSopOperation} from '../../../operations/sop/FileFBX';
import {FileGLTFSopOperation} from '../../../operations/sop/FileGLTF';
import {FileJSONSopOperation} from '../../../operations/sop/FileJSON';
import {FileMPDSopOperation} from '../../../operations/sop/FileMPD';
import {FileOBJSopOperation} from '../../../operations/sop/FileOBJ';
import {FilePLYSopOperation} from '../../../operations/sop/FilePLY';
import {FileSTLSopOperation} from '../../../operations/sop/FileSTL';
import {FileSVGSopOperation} from '../../../operations/sop/FileSVG';
import {HemisphereLightSopOperation} from '../../../operations/sop/HemisphereLight';
import {FilePDBSopOperation} from '../../../operations/sop/FilePDB';
import {HierarchySopOperation} from '../../../operations/sop/Hierarchy';
import {IcosahedronSopOperation} from '../../../operations/sop/Icosahedron';
import {InstanceSopOperation} from '../../../operations/sop/Instance';
import {InstanceUpdateSopOperation} from '../../../operations/sop/InstanceUpdate';
import {JitterSopOperation} from '../../../operations/sop/Jitter';
import {LookAtSopOperation} from '../../../operations/sop/LookAt';
import {MergeSopOperation} from '../../../operations/sop/Merge';
import {MetaballSopOperation} from '../../../operations/sop/Metaball';
import {MaterialSopOperation} from '../../../operations/sop/Material';
import {MaterialPropertiesSopOperation} from '../../../operations/sop/MaterialProperties';
import {NullSopOperation} from '../../../operations/sop/Null';
import {ObjectPropertiesSopOperation} from '../../../operations/sop/ObjectProperties';
import {ObjectsLayoutSopOperation} from '../../../operations/sop/ObjectsLayout';
import {OceanPlaneSopOperation} from '../../../operations/sop/OceanPlane';
import {OrthographicCameraSopOperation} from '../../../operations/sop/OrthographicCamera';
import {PaletteSopOperation} from '../../../operations/sop/Palette';
import {PeakSopOperation} from '../../../operations/sop/Peak';
import {PerspectiveCameraSopOperation} from '../../../operations/sop/PerspectiveCamera';
import {PlaneSopOperation} from '../../../operations/sop/Plane';
import {PlaneHelperSopOperation} from '../../../operations/sop/PlaneHelper';
import {PolarTransformSopOperation} from '../../../operations/sop/PolarTransform';
import {PolywireSopOperation} from '../../../operations/sop/Polywire';
import {PointLightSopOperation} from '../../../operations/sop/PointLight';
import {RaySopOperation} from '../../../operations/sop/Ray';
import {ReflectorSopOperation} from '../../../operations/sop/Reflector';
import {RestAttributesSopOperation} from '../../../operations/sop/RestAttributes';
import {RoundedBoxSopOperation} from '../../../operations/sop/RoundedBox';
import {ScatterSopOperation} from '../../../operations/sop/Scatter';
import {SetChildrenSopOperation} from '../../../operations/sop/SetChildren';
import {SetGeometrySopOperation} from '../../../operations/sop/SetGeometry';
import {ShearSopOperation} from '../../../operations/sop/Shear';
import {SortSopOperation} from '../../../operations/sop/Sort';
import {SphereSopOperation} from '../../../operations/sop/Sphere';
import {SpotLightSopOperation} from '../../../operations/sop/SpotLight';
import {SubdivideSopOperation} from '../../../operations/sop/Subdivide';
import {TextureCopySopOperation} from '../../../operations/sop/TextureCopy';
import {TexturePropertiesSopOperation} from '../../../operations/sop/TextureProperties';
import {TorusSopOperation} from '../../../operations/sop/Torus';
import {TorusKnotSopOperation} from '../../../operations/sop/TorusKnot';
import {TubeSopOperation} from '../../../operations/sop/Tube';
import {TransformSopOperation} from '../../../operations/sop/Transform';
import {TransformResetSopOperation} from '../../../operations/sop/TransformReset';
import {UvLayoutSopOperation} from '../../../operations/sop/UvLayout';
import {UvTransformSopOperation} from '../../../operations/sop/UvTransform';
import {UvUnwrapSopOperation} from '../../../operations/sop/UvUnwrap';

import {PolyEngine} from '../../../Poly';
export class SopRegister {
	static run(poly: PolyEngine) {
		poly.registerOperation(AddSopOperation);
		poly.registerOperation(AmbientLightSopOperation);
		poly.registerOperation(AreaLightSopOperation);
		poly.registerOperation(AttribAddMultSopOperation);
		poly.registerOperation(AttribCastSopOperation);
		poly.registerOperation(AttribCopySopOperation);
		poly.registerOperation(AttribCreateSopOperation);
		poly.registerOperation(AttribNormalizeSopOperation);
		poly.registerOperation(AttribFromTextureSopOperation);
		poly.registerOperation(AttribIdSopOperation);
		poly.registerOperation(AttribPromoteSopOperation);
		poly.registerOperation(AttribRenameSopOperation);
		poly.registerOperation(AttribSetAtIndexSopOperation);
		poly.registerOperation(AudioNotesSopOperation);
		poly.registerOperation(AxesHelperSopOperation);
		poly.registerOperation(BboxScatterSopOperation);
		poly.registerOperation(BooleanSopOperation);
		poly.registerOperation(BoxSopOperation);
		poly.registerOperation(BoxLinesSopOperation);
		poly.registerOperation(BVHSopOperation);
		poly.registerOperation(BVHVisualizerSopOperation);
		poly.registerOperation(CameraControlsSopOperation);
		poly.registerOperation(CameraFrameModeSopOperation);
		poly.registerOperation(CameraCSSRendererSopOperation);
		poly.registerOperation(CameraPostProcessSopOperation);
		poly.registerOperation(CameraProjectSopOperation);
		poly.registerOperation(CameraRendererSopOperation);
		poly.registerOperation(CameraRenderSceneSopOperation);
		poly.registerOperation(CapsuleSopOperation);
		poly.registerOperation(CenterSopOperation);
		poly.registerOperation(CircleSopOperation);
		poly.registerOperation(ClipSopOperation);
		poly.registerOperation(CurveFromPointsSopOperation);
		poly.registerOperation(CurveGetPointSopOperation);
		poly.registerOperation(CSS2DObjectSopOperation);
		poly.registerOperation(DecalSopOperation);
		poly.registerOperation(DirectionalLightSopOperation);
		poly.registerOperation(EmptyObjectSopOperation);
		// poly.registerOperation(FileSopOperation);
		poly.registerOperation(FileDRCSopOperation);
		poly.registerOperation(FileFBXSopOperation);
		poly.registerOperation(FileGLTFSopOperation);
		poly.registerOperation(FileJSONSopOperation);
		poly.registerOperation(FileMPDSopOperation);
		poly.registerOperation(FileOBJSopOperation);
		poly.registerOperation(FilePDBSopOperation);
		poly.registerOperation(FilePLYSopOperation);
		poly.registerOperation(FileSTLSopOperation);
		poly.registerOperation(FileSVGSopOperation);
		poly.registerOperation(HemisphereLightSopOperation);
		poly.registerOperation(HierarchySopOperation);
		poly.registerOperation(IcosahedronSopOperation);
		poly.registerOperation(InstanceSopOperation);
		poly.registerOperation(InstanceUpdateSopOperation);
		poly.registerOperation(JitterSopOperation);
		poly.registerOperation(LookAtSopOperation);
		poly.registerOperation(MergeSopOperation);
		poly.registerOperation(MetaballSopOperation);
		poly.registerOperation(MaterialSopOperation);
		poly.registerOperation(MaterialPropertiesSopOperation);
		poly.registerOperation(NullSopOperation);
		poly.registerOperation(ObjectPropertiesSopOperation);
		poly.registerOperation(ObjectsLayoutSopOperation);
		poly.registerOperation(OceanPlaneSopOperation);
		poly.registerOperation(OrthographicCameraSopOperation);
		poly.registerOperation(PaletteSopOperation);
		poly.registerOperation(PeakSopOperation);
		poly.registerOperation(PerspectiveCameraSopOperation);
		poly.registerOperation(PlaneSopOperation);
		poly.registerOperation(PlaneHelperSopOperation);
		poly.registerOperation(PointLightSopOperation);
		poly.registerOperation(PolarTransformSopOperation);
		poly.registerOperation(PolywireSopOperation);
		poly.registerOperation(RaySopOperation);
		poly.registerOperation(ReflectorSopOperation);
		poly.registerOperation(RestAttributesSopOperation);
		poly.registerOperation(RoundedBoxSopOperation);
		poly.registerOperation(ScatterSopOperation);
		poly.registerOperation(SetChildrenSopOperation);
		poly.registerOperation(SetGeometrySopOperation);
		poly.registerOperation(ShearSopOperation);
		poly.registerOperation(SortSopOperation);
		poly.registerOperation(SphereSopOperation);
		poly.registerOperation(SpotLightSopOperation);
		poly.registerOperation(SubdivideSopOperation);
		poly.registerOperation(TextureCopySopOperation);
		poly.registerOperation(TexturePropertiesSopOperation);
		poly.registerOperation(TorusSopOperation);
		poly.registerOperation(TorusKnotSopOperation);
		poly.registerOperation(TransformSopOperation);
		poly.registerOperation(TransformResetSopOperation);
		poly.registerOperation(TubeSopOperation);
		poly.registerOperation(UvLayoutSopOperation);
		poly.registerOperation(UvTransformSopOperation);
		poly.registerOperation(UvUnwrapSopOperation);

		poly.registerNode(ActorSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(AddSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(AmbientLightSopNode, CATEGORY_SOP.LIGHTS);
		poly.registerNode(AnimationCopySopNode, CATEGORY_SOP.ANIMATION);
		// poly.registerNode(AnimationMixerSopNode, CATEGORY_SOP.ANIMATION);
		poly.registerNode(AreaLightSopNode, CATEGORY_SOP.LIGHTS);
		poly.registerNode(AttribAddMultSopNode, CATEGORY_SOP.ATTRIBUTE);
		// if (process.env.NODE_ENV == 'development') {
		// 	poly.registerNode(AttribAudioAnalyserSopNode, CATEGORY_SOP.AUDIO);
		// }
		poly.registerNode(AttribCastSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribCopySopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribCreateSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribDeleteSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribFromTextureSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribIdSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribNormalizeSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribPromoteSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribRemapSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribRenameSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribSetAtIndexSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AttribTransferSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(AudioNotesSopNode, CATEGORY_SOP.AUDIO);
		poly.registerNode(AxesHelperSopNode, CATEGORY_SOP.HELPERS);
		poly.registerNode(BboxScatterSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(BlendSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(BooleanSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(BoxSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(BoxLinesSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(BVHSopNode, CATEGORY_SOP.ADVANCED);
		poly.registerNode(BVHVisualizerSopNode, CATEGORY_SOP.ADVANCED);
		poly.registerNode(CacheSopNode, CATEGORY_SOP.MISC);
		poly.registerNode(CameraControlsSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(CameraFrameModeSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(CameraCSSRendererSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(CameraPlaneSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(CameraPostProcessSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(CameraProjectSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(CameraRendererSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(CameraRenderSceneSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(CapsuleSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(CenterSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(CircleSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(Circle3PointsSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(ClipSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(CodeSopNode, CATEGORY_SOP.ADVANCED);
		poly.registerNode(ColorSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(ConeSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(CopySopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(CurveFromPointsSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(CurveGetPointSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(CSS2DObjectSopNode, CATEGORY_SOP.PRIMITIVES);
		// poly.registerNode(Css3DObjectSopNode, CATEGORY_SOP.PRIMITIVES); // not working yet
		poly.registerNode(DataSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(DataUrlSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(DecalSopNode, CATEGORY_SOP.MISC);
		poly.registerNode(DelaySopNode, CATEGORY_SOP.MISC);
		poly.registerNode(DeleteSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(DirectionalLightSopNode, CATEGORY_SOP.LIGHTS);
		poly.registerNode(DrawRangeSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(EmptyObjectSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(ExporterSopNode, CATEGORY_SOP.ADVANCED);
		poly.registerNode(FaceSopNode, CATEGORY_SOP.MODIFIER);
		if (process.env.NODE_ENV == 'development') {
			poly.registerNode(FacetSopNode, CATEGORY_SOP.MODIFIER);
		}
		// poly.registerNode(FileSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileDRCSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileFBXSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileGLTFSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileJSONSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileMPDSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileMultiGLTFSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileMultiOBJSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileOBJSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FilePDBSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FilePLYSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileSTLSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FileSVGSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(FuseSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(HemisphereLightSopNode, CATEGORY_SOP.LIGHTS);
		poly.registerNode(HeightMapSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(HexagonsSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(HierarchySopNode, CATEGORY_SOP.MISC);
		poly.registerNode(IcosahedronSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(InstanceSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(InstanceUpdateSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(InstancesCountSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(JitterSopNode, CATEGORY_SOP.MODIFIER);
		// if (process.env.NODE_ENV == 'development') {
		// 	poly.registerNode(JsPointSopNode, CATEGORY_SOP.ADVANCED);
		// }
		poly.registerNode(LayerSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(LightMixerSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(LineSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(LodSopNode, CATEGORY_SOP.ADVANCED);
		poly.registerNode(LookAtSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(MaterialSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(MaterialPropertiesSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(MergeSopNode, CATEGORY_SOP.FLOW);

		poly.registerNode(MetaballSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(NoiseSopNode, CATEGORY_SOP.MISC);
		poly.registerNode(NormalsSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(NormalsHelperSopNode, CATEGORY_SOP.HELPERS);
		poly.registerNode(NullSopNode, CATEGORY_SOP.FLOW);
		poly.registerNode(ObjectMergeSopNode, CATEGORY_SOP.INPUT);
		poly.registerNode(ObjectPropertiesSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(ObjectsLayoutSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(OceanPlaneSopNode, CATEGORY_SOP.ADVANCED);
		poly.registerNode(OperationsComposerSopNode, CATEGORY_SOP.ADVANCED, {userAllowed: false});
		poly.registerNode(OrthographicCameraSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(PaletteSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(ParticlesSystemGpuSopNode, CATEGORY_SOP.DYNAMICS);
		poly.registerNode(PeakSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(PerspectiveCameraSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(PhysicsGroundSopNode, CATEGORY_SOP.PHYSICS);
		if (process.env.NODE_ENV == 'development') {
			poly.registerNode(PhysicsJointsSopNode, CATEGORY_SOP.PHYSICS);
		}
		poly.registerNode(PhysicsRBDAttributesSopNode, CATEGORY_SOP.PHYSICS);
		poly.registerNode(PhysicsWorldSopNode, CATEGORY_SOP.PHYSICS);
		poly.registerNode(PlaneSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(PlaneHelperSopNode, CATEGORY_SOP.HELPERS);
		poly.registerNode(PolarTransformSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(PointSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(PointLightSopNode, CATEGORY_SOP.LIGHTS);
		poly.registerNode(PolywireSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(RaySopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(ReflectorSopNode, CATEGORY_SOP.RENDER);
		poly.registerNode(ResampleSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(RestAttributesSopNode, CATEGORY_SOP.ATTRIBUTE);
		poly.registerNode(RoundedBoxSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(ScatterSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(SetChildrenSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(SetGeometrySopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(SkeletonHelperSopNode, CATEGORY_SOP.HELPERS);
		poly.registerNode(SkinSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(ShearSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(SolverSopNode, CATEGORY_SOP.ADVANCED);
		poly.registerNode(SolverPreviousFrameSopNode, CATEGORY_SOP.ADVANCED);
		poly.registerNode(SortSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(SphereSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(SplitSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(SpotLightSopNode, CATEGORY_SOP.LIGHTS);
		poly.registerNode(SubdivideSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(SubnetSopNode, CATEGORY_SOP.SUBNET);
		poly.registerNode(
			SubnetInputSopNode,
			CATEGORY_SOP.SUBNET /*{
			// TODO: use "except" so that it works inside PolyNodes
			// only: [`${NodeContext.SOP}/${SubnetSopNode.type()}`, `${NodeContext.SOP}/poly`],
		}*/
		);
		poly.registerNode(
			SubnetOutputSopNode,
			CATEGORY_SOP.SUBNET /*{
			// only: [`${NodeContext.SOP}/${SubnetSopNode.type()}`, `${NodeContext.SOP}/poly`],
		}*/
		);
		poly.registerNode(SwitchSopNode, CATEGORY_SOP.FLOW);
		poly.registerNode(TetrahedronSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(TextSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(TextureCopySopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(TexturePropertiesSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(TorusSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(TorusKnotSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(TransformSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(TransformCopySopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(TransformMultiSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(TransformResetSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(TubeSopNode, CATEGORY_SOP.PRIMITIVES);
		poly.registerNode(UvLayoutSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(UvProjectSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(UvTransformSopNode, CATEGORY_SOP.MODIFIER);
		poly.registerNode(UvUnwrapSopNode, CATEGORY_SOP.MODIFIER);
		// networks
		poly.registerNode(ActorsNetworkSopNode, CATEGORY_SOP.NETWORK);
		poly.registerNode(AnimationsNetworkSopNode, CATEGORY_SOP.NETWORK);
		poly.registerNode(AudioNetworkSopNode, CATEGORY_SOP.NETWORK);
		poly.registerNode(CopNetworkSopNode, CATEGORY_SOP.NETWORK);
		poly.registerNode(CsgNetworkSopNode, CATEGORY_SOP.NETWORK);
		poly.registerNode(EventsNetworkSopNode, CATEGORY_SOP.NETWORK);
		poly.registerNode(MaterialsNetworkSopNode, CATEGORY_SOP.NETWORK);
		poly.registerNode(PostProcessNetworkSopNode, CATEGORY_SOP.NETWORK);
		poly.registerNode(RenderersNetworkSopNode, CATEGORY_SOP.NETWORK);
	}
}
